export default __webpack_public_path__ + "static/media/GR001551.7b669dba.JPG";